import { useNavigate } from 'react-router';
import { Paths } from '@src/routes/paths';
import { SampleDto } from '@src/types/types';
import { useImpersonate } from '@contexts/ImpersonateContext.tsx';
import { SampleTeaserContent } from '../sample-details/SampleTeaserContent';

export default function SampleTeaser({ sample }: { sample: SampleDto }) {
  const navigate = useNavigate();
  const { impersonateSampleId, isImpersonating } = useImpersonate();
  const goToResult = () =>
    navigate(
      `${Paths.RESULT}/${sample.id}${isImpersonating ? `?impersonate=${impersonateSampleId}` : ''}`,
    );

  return <SampleTeaserContent sample={sample} goToResult={goToResult} />;
}
